import React, { type ReactNode } from "react";

export function formatAuditDisplayValue(val: unknown): ReactNode {
  if (val === null || val === undefined || val === "")
    return <span className="italic text-[#94A3B8]">empty</span>;
  if (Array.isArray(val))
    return val.length === 0 ? (
      <span className="italic text-[#94A3B8]">none</span>
    ) : (
      val.join(", ")
    );
  return String(val);
}

type RelationValueVariant = "from" | "to";

type RelationValueListProps = {
  relationKey: string;
  value: unknown;
  variant: RelationValueVariant;
  formatAuditRelationValue: (
    relationKey: string,
    val: unknown,
  ) => string | string[] | null;
};

export function RelationValueList({
  relationKey,
  value,
  variant,
  formatAuditRelationValue,
}: RelationValueListProps) {
  const formatted = formatAuditRelationValue(relationKey, value);

  if (formatted === null) {
    return (
      <span className="italic text-[#94A3B8]">
        {value === null || value === undefined || value === "" ? "empty" : "none"}
      </span>
    );
  }

  const cls =
    variant === "from"
      ? "text-[#64748B] line-through decoration-[#94A3B8]"
      : "font-medium text-[#16A34A]";

  if (typeof formatted === "string") {
    return <span className={cls}>{formatted}</span>;
  }

  return (
    <ul className={`list-disc space-y-0.5 pl-4 ${cls}`}>
      {formatted.map((line, index) => (
        <li key={index}>{line}</li>
      ))}
    </ul>
  );
}
